/**
 * Single source of truth for homepage FAQs.
 *
 * Used by:
 *   - components/Home/FAQ.jsx (rendered UI)
 *   - app/(public)/page.js (FAQPage JSON-LD for AEO + Google rich results)
 *
 * Keeping the rendered Q&A and the JSON-LD identical is required by Google's
 * FAQPage policy. Edit answers here, never inline in the component.
 */

export const homepageFaqs = [
  {
    question: "What is Prep5?",
    answer:
      "Prep5 is Salesably's AI-powered sales preparation tool. Powered by Sabine, your team's AI sales enablement agent, it automates prospect research, generates personalized outreach, and prepares your reps for every call. Just chat naturally with Sabine — she knows your offers, personas, and methodology to deliver preparation that matters.",
  },
  {
    question: "How does Prep5 work?",
    answer:
      "Chat with Sabine. Say 'research John Smith at Acme Corp' or 'write a cold email for this prospect.' Sabine searches LinkedIn, Exa, the web, and other sources, then creates personalized content based on your offers and buyer personas. She remembers context throughout your conversation.",
  },
  {
    question: "Can I research both people and companies?",
    answer:
      "Absolutely. Prep5 supports in-depth research for individuals (via LinkedIn URLs) and companies (via websites or names). Each new prospect uses 1 credit; call briefs and company research are free. You'll get actionable insights like personal backgrounds, company news, financials, and persona matching to help you connect effectively.",
  },
  {
    question: "What company research does Prep5 provide?",
    answer:
      "Prep5 generates strategic initiatives automatically, plus company news, industry analysis, market positioning, financial insights, and persona discovery within the organization. Company research is always free, with optional on-demand expansions for deeper details.",
  },
  {
    question: "How fast is the company research?",
    answer:
      "Core strategic initiatives stream in under 5 seconds for quick prep. Additional analyses, like market trends or financials, can be triggered instantly when needed, ensuring you get what you need without delays.",
  },
  {
    question: "Who can benefit from using Prep5?",
    answer:
      "Prep5 is built for sales reps, account executives, sales leaders, and teams of any size. Whether you're preparing for calls or generating personalized outreach, Sabine helps your team execute at a level the competition can't match.",
  },
  {
    question: "What can I ask Sabine to do?",
    answer:
      "Research prospects and companies, write cold emails and LinkedIn messages, create call scripts and discovery questions, find similar companies, prepare for meetings, and email you the results. Just describe what you need in natural language. Sabine has access to research tools (Exa, LinkedIn, web search), your saved offers and personas, and can email research summaries directly to your inbox.",
  },
  {
    question: "How does Sabine personalize content?",
    answer:
      "Before generating any content, Sabine checks your defined offers (products/services you sell) and buyer personas (ideal customer profiles). It uses this context along with prospect research to create messaging that's relevant to both your offering and the prospect's situation.",
  },
  {
    question: "Is there a free trial available?",
    answer:
      "Yes. Sign up for 5 free prospects, no credit card required, to test Prep5 on your next prospects or companies. Call briefs and company research are always free. Experience the execution difference firsthand.",
  },
  {
    question: "How can I get support or provide feedback?",
    answer:
      "Contact us via the website's form, email at support@salesably.ai, or our in-app chat. We respond within 24 hours and love hearing your ideas to refine our platform.",
  },
  {
    question: "What integrations does Prep5 support?",
    answer:
      "Prep5 integrates with Pipedrive for bidirectional syncing of prospects and companies — import your deals and contacts or export Prep5 research back to your CRM seamlessly. We also integrate with Google Calendar for auto-suggestions on new prospect meetings. Generate reports, scripts, and follow-ups that you can easily export or copy into your workflow.",
  },
  {
    question: "How secure is my data with Prep5?",
    answer:
      "We prioritize data security with encrypted transmissions and compliant practices. Your searches and reports are processed securely, and we don't retain sensitive information beyond your session. Always use Prep5 responsibly with public data sources.",
  },
  {
    question: "What happens after the free trial?",
    answer:
      "After your 5 free prospects, you can continue with a paid plan tailored to your usage needs. Visit our pricing page or contact support for details on options and to scale as your team grows.",
  },
];
